import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import ourStaff from '../../../helpers/ourStaff';

import DlPictureDashboard from './Dashboard/DlPictureDashboard.js';
import NoMatch from '../../NoMatch';

const championshipsByPlatform = { 'mpg': 1, 'mln': 2, 'mgd': 3};
const DlPicture = props => (
    <div id="dlpicture">
        { !props.location.search ? (
            <Redirect to={{
                pathname: '/dlpicture',
                search: `?championship=${championshipsByPlatform[props.user.mainPlatform]}`,
            }}/>
        ) : (
            <Switch>
                <Route exact path='/dlpicture' component={DlPictureDashboard} />
                <Route component={NoMatch} />
            </Switch>
        )}
    </div>
);

DlPicture.propTypes = {
    user: PropTypes.object.isRequired
};

export default connect(
    state => ({ user: ourStaff[state.authentication.userId] || state.authentication.user || {} })
)(DlPicture);



// WEBPACK FOOTER //
// ./src/pages/Tools/DlPicture/index.js